"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CALLDATA = void 0;
/**
 * Exports containing utils that allow inclusion of calldata decoder info in signing requests. If
 * calldata decoder info is packed into the request, it is used to decode the calldata in the
 * request. It is optional.
 */
var evm_1 = require("./evm");
exports.CALLDATA = {
    EVM: {
        type: 1,
        parsers: {
            parseSolidityJSONABI: evm_1.parseSolidityJSONABI,
            parseCanonicalName: evm_1.parseCanonicalName,
        },
    },
};
